import DatesPage from './page';
import PanelCalendarPlace from './panelCalendarPlace';
import PanelDates from './panelDates';

export { PanelCalendarPlace, PanelDates };

export default DatesPage;
